import axios from "axios";
import { useQuery } from "react-query";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getActiveSplcEmployees = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/ActiveSplcEmployees`
  );
  return data;
};

export const useGetActiveSplcEmployees = () => {
  return useQuery("ActiveSplcEmployees", getActiveSplcEmployees, {
    refetchOnWindowFocus: false,
  });
};
